$(document).ready(function(){
  if($('.native-recommended-product-popup-section').length > 0) {
      var productId = $('.native-recommended-product-popup-section').data('product-id');
      var productHandle = $('.native-recommended-product-popup-section').data('product-handle');
      if(productHandle == '') {
        $.ajax({
          type: 'GET',
          url: '/recommendations/products?section_id=product-recommendation-popup&limit='+ 3 +'&product_id=' + productId,
            success: function (data) {

              $('.native-recommended-product-popup-section').parent().html($(data).html());
              $('.purchase-details .add_to_cart').click(function(){
                $('.native-recommended-product-popup-section').addClass('active');
                $('body').addClass('active-popup');

              });
              $('.popup-close').click(function(){
                $('.native-recommended-product-popup-section').removeClass('active');
                $('body').removeClass('active-popup');
                $('body').addClass('blocked-scroll');
              });
            },
            error: function () {
                console.error("Recommendations content load failed");
            }
        });
      } else {
        console.log("dhir");
        $('.purchase-details .add_to_cart').click(function(){
          $('.native-recommended-product-popup-section').addClass('active');
          $('body').addClass('active-popup');
        });
        $('.popup-close').click(function(){
          $('.native-recommended-product-popup-section').removeClass('active');
          $('body').removeClass('active-popup');
          $('body').addClass('blocked-scroll');
        });
      }
  }

  var fillInPage = (function() {
    var alaskaCityNames = [
      'Anchorage',
      'Fairbanks',
      'Juneau',
      'Knik-Fairview',
      'Badger',
      'College',
      'Lakes',
      'Meadow Lakes',
      'Wasilla',
      'Tanaina',
      'Kalifornsky',
      'Sitka',
      'Ketchikan',
      'Kenai',
      'Steele Creek',
      'Bethel',
      'Chena Ridge',
      'Sterling',
      'Palmer',
      'Gateway',
      'Kodiak',
      'Homer',
      'Fishhook',
      'Utqiagvik',
      'Farmers Loop',
      'Nikiski',
      'Soldotna',
      'Unalaska',
      'Valdez',
      'Big Lake',
      'Nome',
      'Butte',
      'Goldstream',
      'Kotzebue',
      'Petersburg',
      'Farm Loop',
      'Seward',
      'Eielson AFB',
      'Cordova',
      'Ester',
      'Deltana',
      'Dillingham',
      'Fritz Creek',
      'North Pole',
      'Willow',
      'Ridgeway',
      'Bear Creek',
      'Wrangell',
      'Anchor Point',
      'Houston',
      'Point MacKenzie',
      'Kodiak Station',
      'Haines',
      'Akutan',
      'Susitna North',
      'Lazy Mountain',
      'Cohoe',
      'Metlakatla',
      'Hooper Bay',
      'Diamond Ridge',
      'Prudhoe Bay',
      'Tok',
      'Skagway',
      'Funny River',
      'Salamatof',
      'Talkeetna',
      'Sutton-Alpine',
      'Craig',
      'Buffalo Soapstone',
      'Salcha',
      'Healy',
      'Chevak',
      'Hoonah',
      'Delta Junction',
      'Ninilchik',
      'Savoonga',
      'Point Hope',
      'Emmonak',
      'Togiak',
      'Kwethluk',
      'Selawik',
      'Knik River',
      'Quinhagak',
      'Unalakleet',
      'King Cove',
      'Alakanuk',
      'Womens Bay',
      'Klawock',
      'Happy Valley',
      'Kipnuk',
      'Noorvik',
      'Akiachak',
      'Toksook Bay',
      'Yakutat',
      'Gustavus and Kotlik',
      'Two Rivers',
      'Fox River',
      'Gambell',
      'Stebbins',
      'Wainwright',
      'Kasigluk',
      'Mountain Village',
      'Pilot Station',
      'Pleasant Valley',
      'Scammon Bay',
      "St. Mary's",
      'Nunapitchuk',
      'Sand Point',
      'Shishmaref and Kachemak',
      'Noatak',
      'Buckland',
      'Kake',
      'Moose Creek',
      'Kasilof',
      'Nuiqsut and New Stuyahok',
      'Napaskiak',
      'Aniak',
      'Chefornak',
      'South Van Horn',
      'Trapper Creek',
      'Marshall',
      'Manokotak',
      'Kongiganak',
      'Thorne Bay',
      'Galena',
      'Naknek',
      'Tuntutuliak',
      'Akiak',
      'St. Michael',
      'Kiana',
      'Kivalina Big Delta and Tuluksak',
      'Glennallen	',
      'Brevig Mission and Fort Yukon',
      'Anaktuvuk Pass',
      'Russian Mission',
      'St. Paul',
      'Tununak',
      'Fox',
      'Eek',
      'False Pass',
      'Atmautluak',
      'Saxman',
      'Hydaburg and Kwigillingok',
      'Glacier View',
      'Elim',
      'Napakiak and Nenana',
      'Angoon',
      'Cooper Landing',
      'Copper Center',
      'Point Lay',
      'Nikolaevsk',
      'Koyuk',
      'Fort Greely',
      'King Salmon',
      'Nightmute',
      'Huslia',
      'McGrath',
      'Kaktovik',
      'Lower Kalskag',
      'Atqasuk',
      'Ambler',
      'Whittier and Shungnak',
      'Goodnews Bay',
      'Chickaloon',
      'Harding-Birch Lakes',
      'Teller',
      'Nanwalek',
      'Tanana',
      'Tazlina',
      'Nulato',
      'Seldovia',
      'Northway and Kenny Lake',
      'Moose Pass',
      'Nunam Iqua',
      'Old Harbor',
      'Upper Kalskag and Shaktoolik',
      'Aleknagik',
      'Grayling',
      'Newtok',
      'Clam Gulch',
      'Mekoryuk',
      'Venetie',
      'Cantwell',
      'Seldovia Village',
      'Kobuk',
      'Willow Creek',
      'Port Alsworth',
      'White Mountain',
      'Koliganek',
      'Deering',
      'Allakaket and Anderson',
      'Holy Cross',
      'Golovin',
      'Adak',
      'Port Lions',
      'Manley Hot Springs and Gakona',
      'Newhalen and Wales',
      'Denali Park',
      'Port Graham',
      'Hope',
      'Mud Bay',
      'Kaltag',
      'Kokhanok and Tyonek',
      'Arctic Village',
      'Minto',
      'Tanacross',
      'Naukati Bay',
      'Ruby',
      'Nondalton',
      'Mentasta Lake and Coffman Cove',
      'Tetlin',
      'Pitkas Point and Mosquito Lake',
      'Crown Point',
      'Tenakee Springs and Slana',
      'Ekwok and Silver Springs',
      'Gulkana',
      'Ouzinkie',
      'Iliamna',
      'McCarthy',
      'Chuathbaluk',
      'Twin Hills',
      'Chitina',
      'Port Heiden and Shageluk',
      'Mertarvik',
      'Pelican and Koyukuk',
      'Chignik',
      'Primrose',
      'Sleetmute',
      'Circle',
      'Crooked Creek and Tatitlek',
      'Nikolai',
      'Perryville',
      'Klukwan',
      'Whale Pass',
      'Hughes',
      'Eagle and Diomede',
      'Northway Village',
      'Lowell Point',
      'Port Alexander',
      'Chignik Lagoon',
      'Whitestone',
      'Oscarville Anvik and Pilot Point',
      'Levelock',
      'Igiugig',
      "St. George South Naknek and Clark's Point",
      'Central',
      'Hollis',
      'Akhiok',
      'Skwentna',
      'Chiniak Chignik Lake and Dry Creek',
      'Chistochina and Halibut Cove',
      'Chenega',
      'Rampart and Stony River',
      'Takotna and Chalkyitsik',
      'Platinum and Tonsina',
      'Atka and Eagle Village',
      'Cold Bay',
      'Hyder and Beaver',
      'Nelchina',
      'Pedro Bay',
      'Northway Junction and Nelson Lagoon',
      'Excursion Inlet',
      'Egegik and Nikolski',
      'Stevens Village',
      'Alcan Border Mendeltna and Port Protection',
      'Birch Creek',
      'Coldfoot Larsen Bay and Beluga',
      'Lake Minchumina and Kasaan',
      'Lutak',
      'Karluk and Petersville',
      'Paxson',
      'Covenant Life and Edna Bay',
      'Healy Lake Elfin Cove and Eureka Roadhouse',
      'Bettles Dot Lake Village and Game Creek',
      'Red Devil',
      'Kupreanof and Dot Lake',
      'Chase',
      'Four Mile Road',
      'Ferry',
      'Livengood',
      'Alatna Lake Louise and Sunrise',
      'Lime Village',
      'Tolsona Chicken Evansville and Point Baker',
      'Susitna',
      'Point Possession',
      'Pope-Vannoy Landing',
      'Wiseman Red Dog Mine and Aleneva',
      'Portage Creek and Ugashik',
      'Nabesna and Whitestone Logging Camp',
      'Hobart Bay and Ivanof Bay'
    ]
    var updateCityText = function(geoipResponse) {

      /*
       * It's possible that we won't have any names for this city.
       * For language codes with a special character such as pt-BR,
       * replace names.en with names['pt-BR'].
      */
      var cityName = geoipResponse.city.names.en || 'your city';

      if(alaskaCityNames.indexOf(cityName) > -1) {
        $('.alaska-popup-container').addClass('active');
      }
    };

    var onSuccess = function(geoipResponse) {
      updateCityText(geoipResponse);
    };

    // If we get an error, we will display an error message
    var onError = function(error) {
    };

    return function() {
      if (typeof geoip2 !== 'undefined') {
        geoip2.city(onSuccess, onError);
      }
    };
  }());

  fillInPage();

  $('.alaska-popup-close').click(function(){
    $('.alaska-popup-container').removeClass('active');
  });

  $('.shipping-item').each(function(){
    var index = $(this).data('item-index');
    $(this).mouseenter(function(){
      $('.shipping-delivery-details').addClass('show-tooltip' + index);
    });
    $(this).mouseleave(function(){
      $('.shipping-delivery-details').removeClass('show-tooltip' + index);
    });
  });
});

function makeTimer() {

//		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");
var website_end_time = jQuery("#promotion_end_time").val();
  var endTime = new Date(website_end_time);
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;

    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft) / 3600);
    var minutes = Math.floor((timeLeft  - (hours * 3600 )) / 60);
    var seconds = Math.floor((timeLeft  - (hours * 3600) - (minutes * 60)));

    if (hours < "10") { hours = "0" + hours; }
    if (minutes < "10") { minutes = "0" + minutes; }
    if (seconds < "10") { seconds = "0" + seconds; }


    jQuery("#hours span").text(hours);
    jQuery("#minutes span").text(minutes);
    jQuery("#seconds span").text(seconds);

}

setInterval(function() { makeTimer(); }, 1000);


$('.homepageSlider__inner').flickity({
 // options
 cellAlign: 'left',
 contain: true
});


$(document).ready(function() {

    //Pdp shipping info

    var p_price = jQuery(".single_price_block").attr("content");
    var economy_price = Math.round((p_price * 10) / 100) ;
    var delivery_price = Math.round((p_price * 20) / 100) ;

   // jQuery(".shipping-item.wrapper.shipping-item1").find(".badge").text("$" + economy_price);
    //jQuery(".shipping-item.wrapper.shipping-item3").find(".badge").text("$" + delivery_price);



  // Swiper: Slider
      new Swiper('.collectionSlider_main_inner .swiper-container', {

          nextButton: '.collectionSlider_main_inner .swiper-button-next',
          prevButton: '.collectionSlider_main_inner .swiper-button-prev',
          slidesPerView: 3,
          allowTouchMove: true,
          centeredSlides: false,
          // threshold: 75,
          preventClicks: false,
          paginationClickable: true,
          loop: false,
          breakpoints: {
            768: {
              slidesPerView: 2,
              loop:false,
              spaceBetween: 10,
            },
            480: {
                slidesPerView: 'auto',
                loop:false,
                spaceBetween: 10,
            }
        }

      });



      new Swiper('.single_tabbed_item_inner .swiper-container', {

        nextButton: '.single_tabbed_item_inner .swiper-button-next',
        prevButton: '.single_tabbed_item_inner .swiper-button-prev',
        slidesPerView: 4,
        allowTouchMove: true,
        centeredSlides: false,
        // threshold: 75,
        preventClicks: false,
        paginationClickable: true,
        loop: false,
        breakpoints: {
          480: {
              slidesPerView: 'auto',
              loop:false
          }
      }

    });

    new Swiper('.productLikedSlider__wrap .swiper-container', {
      nextButton: '.productLikedSlider__wrap .swiper-button-next',
      prevButton: '.productLikedSlider__wrap .swiper-button-prev',
      slidesPerView: 4,
      allowTouchMove: true,
      centeredSlides: false,
      spaceBetween: 30,
      // threshold: 75,
      preventClicks: false,
      paginationClickable: true,
      loop: false,
      breakpoints: {
        767: {
          slidesPerView: 3,
          loop:false
        },
        500: {
            slidesPerView: 2,
            loop:false,
            spaceBetween: 0,
        }
    }
  });

  new Swiper('.storeTeam__slider .swiper-container', {

    nextButton: '.storeTeam__slider .swiper-button-next',
    prevButton: '.storeTeam__slider .swiper-button-prev',
    slidesPerView: 1,
    allowTouchMove: true,
    centeredSlides: false,
    // threshold: 75,
    preventClicks: false,
    paginationClickable: true,
    loop: false,
    breakpoints: {
      480: {
          slidesPerView: 'auto',
          loop:false
      }
  }
})



  });



  $(document).ready(function(){
    $('.moreless-button').click(function() {

      $(this).parents(".singleteamSLider__body").find(".moretext").slideToggle();
      if ($(this).parents(".singleteamSLider__body").find(".moreless-button").text() == "Read more") {
        $(this).text("Read less")
      } else {
        $(this).text("Read more")
      }
    });
});







  jQuery(" .single_tabbed_item:first-child,.tabbedTitle__single:first-child .tabbled_title_text").addClass("active");
  var collection_url = jQuery(".single_tabbed_item.active #active_url").val();
  jQuery(".colelction_viewall").attr("href",collection_url);

  console.log(collection_url);
  $(document).on('click', '.tabbled_title_text', function() {


    jQuery(".tabbled_title_text ").removeClass("active");
    jQuery(this).addClass("active");
    var active_sec =jQuery(".tabbled_title_text.active").attr("data-collection");
    var active_class = "."+active_sec;
    jQuery(".single_tabbed_item").removeClass("active");
    jQuery(active_class).addClass("active");

    console.log(active_class);
    var collection_urls = jQuery(".single_tabbed_item.active #active_url").val();
    jQuery(".colelction_viewall").attr("href",collection_urls);

  });









  $(document).ready(function(){

    function showResults(location) {
      if (location && location !== 'none') {
        var title = location.name;
        var phone = location.phone;
        var direction = "https://www.google.com/maps/search/?api=1&query="+ location.latitude +","+ location.longitude ;
        var info_more = location.website;
        var address = location.address_line_1;
        var city = location.city;
        var state = location.state;
        var post_code = location.postal_code;
        var tele_num = "tel:"+ location.phone;
        var custom_field = location.custom_fields;

        function functiontofindIndexByKeyValue(arraytosearch, key, valuetosearch) {

          for (var i = 0; i < arraytosearch.length; i++) {

          if (arraytosearch[i][key] == valuetosearch) {
          return i;
          }
          }
          return null;
          }

          var index = functiontofindIndexByKeyValue(custom_field, "name", "Office hours");
          if(index !== null ){
            var office_hr = custom_field[index]["value"];
            jQuery('.working-hrs').html(office_hr);
            console.log("boda");
        };

        var map_index = functiontofindIndexByKeyValue(custom_field, "name", "map");
        if( map_index !== null){
          var map = custom_field[map_index]["value"];
          jQuery('.map-area.desktop-map,.mobile-maps-area').html(map);
          console.log(map);
        };
        console.log(index);

        console.log(location);


        jQuery('.store-info-title').text(title );
        jQuery('.store-phone a').text(phone);
        jQuery('.store-phone a').attr('href',tele_num);
        jQuery('.main-address').text(address);
        jQuery('span.city').text(city);
        jQuery('span.state').text(state);
        jQuery('span.post-code').text(post_code);
        jQuery('.button-area-store a.flat-button').attr('href',direction);
        jQuery('.button-area-store a.outline-button').attr('href',info_more);


      } else {
        jQuery('.shopify-section--nearest-store').remove();
      }


    }




  var nearests = lscache.get('nearest-stores');

  // Estimate visitor location - can use any IP geolocation provider
  $.get("https://api.ipbase.com/v2/info?apikey=uDYW2Ov2ojAlGfPnIjVrAJ3uYbJzPB2Kw9US5yDA").then(function(geoipResult) {
    // Call Stockist API
    $.get("https://stockist.co/api/v1/u3601/locations/search", {
      latitude: geoipResult.data.location.latitude,
      longitude: geoipResult.data.location.longitude,
      distance: 250,
      limit: 1,
    }).then(function(searchResults) {
      // Check for result
      var locationss = searchResults.locations;
      var nearests = locationss.length ? locationss[0] : null;
      // Cache the result for 24 hours to improve site performance
      // If no nearby store, save 'none' as a string to distinguish "no stores nearby" vs. "not checked yet"
      lscache.set('nearest-stores', nearests ? nearests : 'none', 60 * 24); // 24 hour expiry
      // Show location to visitor


      showResults(nearests);
    });
  });
});



$(document).ready(function() {
var $carousel = $('.carousel').flickity({
  // options
  cellAlign: 'left',
  contain: true
 });

var $carouselNav = $('.carousel-nav');
var $carouselNavCells = $carouselNav.find('.carousel-cell');

$carouselNav.on( 'click', '.carousel-cell', function( event ) {
var index = $( event.currentTarget ).index();
$carousel.flickity( 'select', index );
});

$(document).on( 'change', '.single-option-selector', function( event ) {
  var slide_selector = $(".varraiant_id").find(':selected').attr('data-activeclass');
  console.log(slide_selector);
  var listItem = $( "."+slide_selector);
  var index = $("."+slide_selector ).index();
  $carousel.flickity( 'select', index );
  console.log(index );
});


var flkty = $carousel.data('flickity');
var navTop  = $carouselNav.position().top;
var navCellHeight = $carouselNavCells.height();
var navHeight = $carouselNav.height();
var total_num = $(".main_product_slider_inner .carousel-cell").length;
var index_num = flkty.selectedIndex+ 1;
$(".carousel-status").text( index_num + ' of ' + total_num);

$carousel.on( 'select.flickity', function() {
// set selected nav cell
$carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
var $selected = $carouselNavCells.eq( flkty.selectedIndex )
  .addClass('is-nav-selected');
// scroll nav
var scrollY = $selected.position().top +
  $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;
$carouselNav.animate({
  scrollTop: scrollY
});
var total_num = $(".main_product_slider_inner .carousel-cell").length;
var index_num = flkty.selectedIndex+ 1;
$(".carousel-status").text( index_num + ' of ' + total_num);
 console.log(total_num,index_num,flkty.selectedIndex );
});

});



$(document).on('click', '.single_info_tab', function() {


jQuery(".single_info_tab").removeClass("active");
jQuery(this).addClass("active");
var active_sec =jQuery(".single_info_tab.active").attr("data-target");
var active_class = "."+active_sec;
jQuery(".single_product_tab_content").removeClass("active");
jQuery(active_class).addClass("active");


});


$('.productTestimonial__container').flickity({
// options
draggable: true,

});

//review on click scroll
$(".review_onclick").click(function() {
jQuery(".single_info_tab").removeClass("active");
jQuery(".single_info_tab[data-target='review']").addClass("active");
jQuery(".single_product_tab_content").removeClass("active");
jQuery(".single_product_tab_content.review").addClass("active");
$('html, body').animate({
  scrollTop: $(".product_informations").offset().top
}, 1000);
});
/*
$(document).ready(function(){
  if($(".shopify-section.shopify-section--product-new-template").length){
  function borderChange(){

    if($(".cps_cart").length){
      jQuery("div#cps-warranty .select-flex select").removeAttr('style');
      var styleattr = jQuery("div#cps-warranty .select-flex select").attr("style");

      if(!styleattr){
        clearInterval(border_check);

      }

   }
  }
  var border_check = setInterval(borderChange,1500);
}

});*/
